import { useEffect, useState } from "react";

/**
 * `true` só depois de `ms` — o que decide se o esqueleto aparece (Fase 6A).
 *
 * **Carregamento rápido não mostra esqueleto.** Uma resposta que chega em 80 ms
 * com um esqueleto na frente pisca duas vezes: o conteúdo some, o esqueleto
 * entra, o conteúdo volta. O olho lê isso como defeito, não como carregamento —
 * e a maior parte das respostas deste app, servidas da mesma máquina, chega bem
 * antes do limiar.
 *
 * Acima dele o esqueleto é obrigatório, e com o **formato do conteúdo**: é o que
 * reserva o espaço e mantém o CLS baixo quando o dado chega.
 *
 * 300 ms é o número da fase. Ele não é uma constante de negócio (invariante 4) —
 * é um limiar de percepção, da mesma família do debounce de digitação.
 */
export const LIMIAR_DO_ESQUELETO_MS = 300;

export function useAtrasado(ativo: boolean, ms = LIMIAR_DO_ESQUELETO_MS): boolean {
  const [passou, setPassou] = useState(false);

  useEffect(() => {
    if (!ativo) {
      setPassou(false);
      return;
    }
    const t = setTimeout(() => setPassou(true), ms);
    return () => clearTimeout(t);
  }, [ativo, ms]);

  return passou;
}
